import { useMemo } from 'react'
import { useCacheSlice } from '../hooks'

export type ReportingEntry = {
  id: number
  prof_id: string
  prof_name: string
  date: string
  start_time: string | null
  end_time: string | null
  units: number
  description: string
  matter_id: string | null
  matter_number: string | null
  matter_description: string | null
  client: string | null
  application: string | null
  task: string | null
  activity: string | null
  document_name: string | null
  exported: boolean
  approved: boolean
  needs_improvement: boolean
  attorney_feedback: string | null
  units_seconds: number | null
}

export type ReportingEntriesData = {
  entries: ReportingEntry[]
  userProfId: string
}

export function useReportingEntriesCache(profId?: string | null) {
  const { data, isLoading, lastFetchedAt } = useCacheSlice('reporting_entries')
  const { entries: allEntries, userProfId } = data as ReportingEntriesData

  // Only show loading on initial fetch (no data yet), not background refreshes
  const isInitialLoading = isLoading && lastFetchedAt === 0

  const entries = useMemo(() => {
    if (!profId) return { tracked: [] as ReportingEntry[], exported: [] as ReportingEntry[] }
    const forProf = allEntries.filter((e) => e.prof_id === profId)
    return {
      tracked: forProf.filter((e) => !e.exported),
      exported: forProf.filter((e) => e.exported),
    }
  }, [allEntries, profId])

  return { ...entries, allEntries, userProfId, isLoading: isInitialLoading }
}
